<template>
  <ApiSimpleSearch
      :url=         "url"
      :cardsMap=    "cardsMap"
      :buttonProps= "buttonProps"
  >
    <v-col cols="12" sm="6" class="pb-0">
      <v-text-field
          hide-details
          clearable
          outlined
          reverse
          dense
          :label=             "$t('field.memberName')"
          :rules=             "memberRules"
          v-model=            "memberName"
          :loading=           "buttonProps.loading"
          :disabled=          "buttonProps.loading"
          @keypress.enter=    "buttonProps.click"
      />
    </v-col>
    <v-col cols="12" sm="6" class="pb-0">
      <v-text-field
          hide-details
          clearable
          outlined
          reverse
          dense
          :label=             "$t('field.cardNumber')"
          :rules=             "cardRules"
          v-model=            "cardNumber"
          :loading=           "buttonProps.loading"
          :disabled=          "buttonProps.loading"
          @keypress.enter=    "buttonProps.click"
      />
    </v-col>
  </ApiSimpleSearch>
</template>

<script>
  import ApiSimpleSearch from '../components/ApiSimpleSearch'

  export default {
    name:       'Claims',
    components: { ApiSimpleSearch },
    data: function() {
      return {
        memberName:   '',
        cardNumber:   '',
        cardRules:    [ value => !value || this.validate(this.cardNumber) ],
        memberRules:  [ value => !value || this.validate(this.memberName) ],
        buttonProps: {
          click:    ()=>{},
          loading:  false,
          disabled: true
        },
        cardsMap: [
          { name: 'Info',     fields: 'YHV_MEMBERNAME,YHV_KARTISNO,YHV_REFCLAIMNUM,YHV_CLAIMTYPEDES,YHV_SERNUM'.split(',') },
          { name: 'Amounts',  fields: 'YHV_LABTOTALS,YHV_PARTTOTALS,YHV_OSLTOTALS,YHV_TOTAL,STATDES'.split(',') }
        ]
      }
    },
    methods: {
      url() {
        return `/apiv1/claims?YHV_MEMBERNAME=${this.memberName}&YHV_KARTISNO=${this.cardNumber}`
      },
      validate(value) {
        return !!(value || '').trim()
      }
    },
    watch:{
      "memberName": {
        handler: function(value) {
          this.buttonProps.disabled = !this.validate(value) || !this.validate(this.cardNumber)
        },
        immediate: true
      },
      "cardNumber": {
        handler: function(value) {
          this.buttonProps.disabled = !this.validate(value) || !this.validate(this.memberName)
        },
        immediate: true
      }
    }
  }
</script>
